module.exports = __webpack_public_path__ + "img/icon-cart-green.ec1d161a.svg";